import React, { useState } from 'react';
import { cloneDeep } from 'lodash';
import BoundedInput from 'components/common/BoundedInput';

const INPUT_CLASS =
	'form-input w-20 rounded border border-indigo-300 bg-transparent px-4 py-1 text-right text-white placeholder:text-white/25';

// Shared footer for all simulation forms: the stoploss and #candles overrides
// plus the cancel/start buttons. The parent form keeps ownership of the
// simulation data (boundaries + selection state) and receives the overrides
// through onStart(stoploss, candles); candles is undefined when the input is
// left empty (= use the system default candle count).
const SimulationFormFooter = ({
	stoploss,
	stoplossMax = 10,
	idPrefix = '-simulation-global-',
	startDisabled,
	onClose,
	onStart,
}) => {
	const [fixedStoploss, setFixedStoploss] = useState(cloneDeep(stoploss));
	const [fixedCandles, setFixedCandles] = useState('');

	const handleStart = () => {
		onStart(fixedStoploss, typeof fixedCandles === 'number' ? fixedCandles : undefined);
	};

	return (
		<>
			<fieldset className="flex font-bold pt-6 pb-2 mt-6 border-t w-full">
				<label
					htmlFor={`${idPrefix}run-simulation-with-stoploss`}
					className="flex items-center break-words cursor-pointer pr-4 flex-1"
				>
					Run Simulation with stoploss
				</label>
				<BoundedInput
					id={`${idPrefix}run-simulation-with-stoploss`}
					onChange={setFixedStoploss}
					value={fixedStoploss}
					min={0}
					max={stoplossMax}
					className={INPUT_CLASS}
				/>
			</fieldset>
			<fieldset className="flex font-bold pb-6 mb-6 border-b w-full">
				<label
					htmlFor={`${idPrefix}run-simulation-with-candles`}
					className="flex items-center break-words cursor-pointer pr-4 flex-1"
				>
					Run Simulation with #candles (empty = default)
				</label>
				<BoundedInput
					id={`${idPrefix}run-simulation-with-candles`}
					onChange={setFixedCandles}
					value={fixedCandles}
					min={500}
					max={50000}
					parseType="int"
					placeholder="default"
					className={INPUT_CLASS}
				/>
			</fieldset>
			<fieldset className="flex justify-end gap-4 pb-6">
				<button
					className="text-white rounded px-4 py-2 bg-blue-500 hover:bg-blue-600 active:bg-blue-500"
					type="button"
					onClick={onClose}
				>
					cancel
				</button>
				<button
					className={`text-white rounded px-4 py-2 ${
						startDisabled
							? 'bg-gray-600 opacity-50 cursor-not-allowed'
							: 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500'
					}`}
					type="button"
					onClick={handleStart}
					disabled={startDisabled}
				>
					start simulation
				</button>
			</fieldset>
		</>
	);
};

export default SimulationFormFooter;
